var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    { staticClass: "header" },
    [
      _c(
        "nav",
        { staticClass: "header__navigation" },
        [
          _c(
            "router-link",
            {
              staticClass: "header__menu",
              attrs: {
                to: { name: "home" },
                exact: "",
                "active-class": "header__menu--active"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("header_1")))])]
          ),
          _c(
            "router-link",
            {
              staticClass: "header__menu",
              attrs: {
                to: { name: "about" },
                "active-class": "header__menu--active"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("header_2")))])]
          ),
          _c(
            "router-link",
            {
              staticClass: "header__menu",
              attrs: {
                to: { name: "work_index" },
                "active-class": "header__menu--active"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("header_6")))])]
          ),
          _c(
            "router-link",
            {
              staticClass: "header__menu",
              attrs: {
                to: { name: "careers_index" },
                "active-class": "header__menu--active"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("header_9")))])]
          ),
          _c(
            "router-link",
            {
              staticClass: "header__menu",
              attrs: {
                to: { name: "blog_index" },
                "active-class": "header__menu--active"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("header_7")))])]
          ),
          _c(
            "router-link",
            {
              staticClass: "header__menu",
              attrs: {
                to: { name: "contact" },
                "active-class": "header__menu--active"
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("header_3")))])]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "header__hamburger" },
        [
          _c("icon-hamburger-view", {
            attrs: { expand: _vm.expand },
            nativeOn: {
              click: function($event) {
                return _vm.clickExpand.apply(null, arguments)
              }
            }
          })
        ],
        1
      ),
      _c(
        "router-link",
        {
          staticClass: "header__bliss",
          attrs: { to: { name: "home" }, "active-class": "" }
        },
        [_c("i", { staticClass: "icon-bliss" })]
      ),
      _c(
        "div",
        { staticClass: "header__ripple" },
        [
          _c("ripple-view", {
            staticClass: "ripple--is-black",
            attrs: { expand: _vm.expand }
          })
        ],
        1
      ),
      _c("sidebar-view", {
        attrs: { expand: _vm.expand },
        on: { "click-item": _vm.clickExpand }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6be6c1a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6be6c1a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/header-view.vue
// module id = 404
// module chunks = 53